export default __webpack_public_path__ + "media/HeroSection-1.65c71706.png";